import { connect } from 'react-redux';

import AddLeaseModal from './AddLeaseModal';
import { createLease } from 'actions/leases';

const mapStateToProps = (state, { subId, sub }) => ({
  initialValues: {
    subscription: null,
    att_subscription: Number(subId),
    imei: sub && sub.device_id,
    lease_type: 'rental',
  },
});

const mapDispatchToProps = {
  createLease,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddLeaseModal);
